// Scheduler
const Scheduler = () => import('@/views/setting/scheduler')

export default {
    path: 'scheduler',
    redirect: '/scheduler',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'scheduler',
            component: Scheduler,
            meta: {
                link: 'scheduler',
                breadcrumb: [
                    { title: 'Setting', url: '/scheduler' },
                    { title: 'Scheduler', active: true },
                ],
                pageTitle: 'Scheduler Setting'
            }
        }
    ]
}